<template>
  <span
    class="app-tooltip-answer"
    :class="{ 'app-tooltip-answer--inline': isInline }"
    :content="tooltip"
    v-tippy="{
      theme: 'light',
      arrow: true,
      interactive: true,
      duration: [250, 250],
    }"
    tabindex="-1"
  >
    <span class="app-tooltip-answer__icon">?</span>
  </span>
</template>

<script>
export default {
  name: 'AppTooltipAnswer',
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    isInline: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss">
.app-tooltip-answer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  overflow: hidden;
  font-weight: 600;
  color: #cecece;
  text-align: center;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  border-radius: 50%;

  @include size(16px);

  &__icon {
    font-size: rem(10);
    font-weight: 700;
    line-height: 16px;
  }

  &--inline {
    display: inline-flex;
  }
}
</style>
